import "./TextInput.css";
import moment from "moment";

export const TextInput = ({
  label,
  name,
  value,
  onChange,
  placeholder = "",
  error,
  maskType, // "currency", "number", "date", "phone", "cnpj", "none"
  type = "text",
}) => {
  const formatValue = (val) => {
    if (maskType === "currency") {
      const raw = val.replace(/\D/g, "");
      const numberValue = Number(raw) / 100;
      return numberValue.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    }
    if (maskType === "date") {
      return moment(val).format("YYYY-MM-DD")
    }
    if (maskType === "phone") {
      const digits = val.replace(/\D/g, "").slice(0, 11);
      const ddd = digits.slice(0, 2);
      const firstPart = digits.slice(2, 7);
      const secondPart = digits.slice(7, 11);

      let formatted = "";
      if (ddd) {
        formatted += `(${ddd}`;
        if (firstPart) {
          formatted += `) ${firstPart}`;
          if (secondPart) {
            formatted += `-${secondPart}`;
          }
        } else {
          formatted += ")";
        }
      }
      return formatted;
    }
    if (maskType === "cnpj") {
      const digits = val.replace(/\D/g, "").slice(0, 14);
      const part1 = digits.slice(0, 2);
      const part2 = digits.slice(2, 5);
      const part3 = digits.slice(5, 8);
      const part4 = digits.slice(8, 12);
      const part5 = digits.slice(12, 14);

      let formatted = "";
      if (part1) formatted += part1;
      if (part2) formatted += `.${part2}`;
      if (part3) formatted += `.${part3}`;
      if (part4) formatted += `/${part4}`;
      if (part5) formatted += `-${part5}`;
      return formatted;
    }
    if (maskType === "cep") {
      const digits = val.replace(/\D/g, "").slice(0, 8);
      const part1 = digits.slice(0, 5);
      const part2 = digits.slice(5, 8);

      let formatted = "";
      if (part1) formatted += part1;
      if (part2) formatted += `-${part2}`;
      return formatted;
    }
    return val;
  };

  const handleChange = (e) => {
    const rawValue = e.target.value;
    const masked = formatValue(rawValue);
    onChange(masked);
  };

  return (
    <div className="textInputWrapper">
      {label && (
        <label className="textInputLabel" htmlFor={name}>{label}</label>
      )}
      <div className="textWrapper">
        <input
          type={maskType === "date" ? "date" : type}
          name={name}
          className="textInput"
          placeholder={placeholder}
          value={formatValue(value)}
          onChange={handleChange}
          inputMode={
            maskType === "currency" || maskType === "number" || maskType === "phone" || maskType === "date" || maskType === "cnpj" || maskType === "cep"
              ? "numeric"
              : "text"
          }
        />
        {error && <div className="textError">{error}</div>}
      </div>
    </div>
  );
};
